var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"at-menu__item",class:[this.active ? 'at-menu__item--active' : '', this.disabled ? 'at-menu__item--disabled' : '']},[(Object.keys(_vm.to).length)?_c('router-link',{ref:"link",staticClass:"at-menu__item-link",attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('div',{staticClass:"at-menu__item-link"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }